import { useState } from 'react';

export let FilmOverview = ({
  overview,
  shortenTruncation,
}: {
  overview: string;
  shortenTruncation?: boolean;
}) => {
  let [isExpanded, setIsExpanded] = useState(false);

  let truncateLength = shortenTruncation ? 80 : 120;
  let needsTruncation = overview.length > truncateLength;

  return (
    <span
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (needsTruncation) setIsExpanded(!isExpanded);
      }}
      className={needsTruncation ? 'cursor-pointer' : ''}
    >
      {isExpanded ? (
        <>
          {overview}
          <span className="block font-medium text-rose-bright">Less</span>
        </>
      ) : (
        <>
          {needsTruncation
            ? overview.slice(0, truncateLength).trim() + '… '
            : overview}
          {needsTruncation && (
            <span className="font-medium text-rose-bright">More</span>
          )}
        </>
      )}
    </span>
  );
};
